import React from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';
import './styles.scss';

const UserProfileSidebarItem = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="user-profile-sidebar-item" onClick={() => navigate(`/users/${user?.id}`)}>
      <UserAvatar userName={user?.userName}/>

      <div className="user-profile-name-wrapper">
        <p className="user-profile-sidebar-name">{user?.userName}</p>
        <p className="user-profile-sidebar-subtitle">Administrator</p>
      </div>
    </div>
  )
};

export const UserAvatar = ({ userName }: { userName: string | undefined }) => {
  return (
    <div className="user-profile-avatar">
      {userName?.slice(0, 1)}
    </div>
  );
}

export default UserProfileSidebarItem;
